<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { dealArr, dealArrMaxNum } from './script/test'
export default {
  data() {
    return {
      clientWidth: 0, //可视区域的宽度
    };
  },
  mounted() {
    const _this = this;
    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
    window.addEventListener("resize", function () {
      return (() => {
        _this.clientWidth = document.body.clientWidth;
      })();
    });
    window.addEventListener("beforeunload", e => {
      this.unloadFn(e);
    });
  },
  created() {
    // let printArr = dealArrMaxNum(dealArr([400]))
    // console.log(printArr)
    this.clientWidth = document.body.clientWidth;
    // this.$store.commit("setClientWidth", this.clientWidth);
  },
  watch: {
    clientWidth: {
      handler: function (newVal, oldVal) {
        // this.$store.commit("setClientWidth", newVal);
      },
    },
  },
  methods: {
    unloadFn() {

    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", e => {
      this.unloadFn(e);
    });
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

body,
html {
  padding: 0;
  margin: 0;
}

#app {
  font-family: "Noto Sans Sc";
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
